import routes from './routes';
import httpClient, { isHttpError } from '../httpClient';

export async function getAllProaqfases() {
  try {
    const response = await httpClient.get(routes.proaqfase);
    return Array.isArray(response.data.registros)
      ? response.data.registros
      : [];
  } catch (error) {
    throw new Error('Erro ao obter lista de Registros: ' + error);
  }
}

export async function getFasesByProaqId(id: string) {
  try {
    const response = await httpClient.get(`/api/proaqfase/proaq/${id}`);

    return response.data;
  } catch (error) {
    throw new Error('Erro ao obter lista de Registros: ' + error);
  }
}

export async function getProaqFase(id: string) {
  try {
    const response = await httpClient.get(`${routes.proaqfase}/${id}`);
    return response.data;
  } catch (error) {
    throw new Error('Erro ao obter Registro: ' + error);
  }
}
export const createProaqFase = async (data: any): Promise<any> => {
  try {
    const response = await httpClient.post(`/api/proaqfase`, data);
    return response.data;
  } catch (error) {
    if (isHttpError(error)) {
      throw new Error(
        error.response?.data?.message || 'Erro ao criar a fase do PROAQ.',
      );
    }
    throw error;
  }
};

export const updateProaqFase = async (id: string, data: any): Promise<any> => {
  try {
    const response = await httpClient.patch(`/api/proaqfase/${id}`, data);
    return response.data;
  } catch (error) {
    if (isHttpError(error)) {
      throw new Error(
        error.response?.data?.message || 'Erro ao atualizar a fase do PROAQ.',
      );
    }
    throw error;
  }
};

export const deleteProaqFase = async (id: string): Promise<any> => {
  try {
    const response = await httpClient.delete(`/api/proaqfase/${id}`);
    return response.data;
  } catch (error) {
    if (isHttpError(error)) {
      throw new Error(
        error.response?.data?.message || 'Erro ao deletar a fase do PROAQ.',
      );
    }
    throw error;
  }
};
